<template>
    <section class="component register address-data bg-white shadow-card rounded-lg p-8 mb-6">
        <header class="pt-2 pb-4 text-center">
            <h2 class="font-bold text-2xl md:text-3xl leading-none">Adresgegevens</h2>
        </header>

        <div class="py-4 md:py-10">
            <div class="input-group flex justify-between sm:flex-no-wrap">
                <validation-provider v-slot="{ errors }" mode="eager" slim :rules="{ regex: /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i }">
                    <div class="input-wrapper mb-3 w-full sm:w-6/12 sm:mr-3" :class="{ 'error': errors[0] }">
                        <label for="postal_code" class="block font-medium leading-6 text-black">Postcode</label>
                        <div class="mt-1 relative rounded-md">
                            <input @change="lookupAddress()" v-model.lazy="addressZipcode" id="postal_code" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>
            
                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-5/12 sm:w-4/12 mr-3" :class="{ 'error': errors[0] }">
                        <label for="street-number" class="block font-medium leading-6 text-black">Huisnummer</label>
                        <div class="mt-1 relative rounded-md">
                            <input @change="lookupAddress()" v-model.lazy="addressNumber" id="street-number" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

                <div class="input-wrapper mb-3 w-5/12 sm:w-3/12">
                    <label for="street-number-addition" class="block font-medium leading-6 text-black">Toevoeging</label>
                    <div class="mt-1 relative rounded-md">
                        <input v-model.lazy="addressNumberAddition" id="street-number-addition" class="form-input border-none block w-full" />
                    </div>
                </div>

            </div>

            <hr class="my-4">

            <div class="input-group sm:flex sm:flex-no-wrap">
                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-full sm:w-6/12 sm:mr-3" :class="{ 'error': errors[0] }">
                        <label for="street" class="block font-medium leading-6 text-black">Straat</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="addressStreet" id="street" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-full sm:w-6/12" :class="{ 'error': errors[0] }">
                        <label for="city" class="block font-medium leading-6 text-black">Woonplaats</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="addressCity" id="city" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

            </div>
        </div>
    </section>
</template>

<script>

import axios from 'axios'

export default {

    methods: {

        async lookupAddress(){

            if(this.addressNumber && this.addressZipcode){

                 const lookup = await axios.post('/api/lookup', {
                     postal_code: this.addressZipcode,
                     street_number: this.addressNumber
                 });
                 

                if(lookup.data.success){
                    
                    this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_street', value: lookup.data.data.street });
                    this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_city', value: lookup.data.data.town });

                }

            }
           
        }
    },

    computed: {
        registrationFormData() {
            return this.$store.state.registrationForm;
        },

        addressStreet: {
            get() { return this.registrationFormData.address_street },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_street', value }) }
        },

        addressCity: {
            get() { return this.registrationFormData.address_city },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_city', value }) }
        },

        addressZipcode: {
            get() { return this.registrationFormData.address_zipcode },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_zipcode', value }) }
        },

        addressNumber: {
            get() { return this.registrationFormData.address_number },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_number', value }) }
        },

        addressNumberAddition: {
            get() { return this.registrationFormData.address_number_addition },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'address_number_addition', value }) }
        },
    }
}
</script>

<style lang="scss" scoped>
.component.register.address-data {

    header {
        border-bottom: 1px solid #DDDDDD;
    }
}
</style>
